<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Manifest Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/freight/containers">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" md="3">
            <span style="color: blue"> Container No: {{ dataItem.Name }}</span
            ><br />
            <span>Date Received: {{ dataItem.DocDate }}</span>
          </v-col>

          <v-col cols="12" xs="12" md="2">
            <span style="color: blue"> Lines: {{ dataItem.Lines }}</span
            ><br />
            <span> Computed Lines: {{ computedLines }}</span>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <span>
              Cost / Line:
              {{
                dataItem.LineCost && dataItem.LineCost.toLocaleString()
              }}</span
            >
          </v-col>

          <v-col cols="12" xs="12" md="2">
            <span
              >Total Value:
              {{ (computedLines * dataItem.LineCost).toLocaleString() }}</span
            >
          </v-col>
        </v-row>

        <!-- manifest list -->
        <v-row>
          <v-col cols="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="manifestData"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- action template -->
              <template v-slot:item.LineCost="{ item }">
                {{ item.LineCost.toLocaleString() }}
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.DocTotal="{ item }">
                {{ item.DocTotal.toLocaleString() }}
              </template>
              <!-- end -->

              <!-- manifest template -->
              <template v-slot:item.invoice="{ item }">
                <v-btn
                  v-if="item.Invoiced == 'N'"
                  color="accent"
                  text
                  @click="openInvoiceDialog(item)"
                  ><v-icon left>mdi-plus</v-icon>
                  Raise Invoice
                </v-btn>

                <v-btn
                  :to="`/manifest/invoice/${item.id}`"
                  v-else
                  color="primary"
                  text
                  ><v-icon left>mdi-eye</v-icon>
                  View Invoice
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <!-- Invoicing  dialog -->
          <v-dialog v-model="invoiceDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Invoice Creation</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="invoiceDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="6">
                      <span style="color: red">
                        Container: {{ dataItem.Name }}</span
                      ><br />
                      <span>Date: {{ dataItem.DocDate }}</span
                      ><br />
                      <span style="font-size: 18px"
                        >Lines: {{ activeItem.Lines }}</span
                      ><br />
                      <span style="font-size: 18px"
                        >Total:
                        {{
                          (
                            activeItem.Lines * activeItem.LineCost
                          ).toLocaleString()
                        }}</span
                      >
                    </v-col>

                    <v-col cols="6">
                      <span style="color: red">{{
                        activeItem.ocrd && activeItem.ocrd.Name
                      }}</span
                      ><br />
                      <span>{{
                        activeItem.ocrd && activeItem.ocrd.PhoneNumber
                      }}</span>
                    </v-col>

                    <v-col cols="12">
                      <v-textarea
                        v-model="Description"
                        label="Description"
                        rows="4"
                        outlined
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        color="accent"
                        @click="createInvoice"
                        :loading="loader"
                      >
                        <v-icon left>mdi-content-save</v-icon> Create Invoice
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of invoicing modal-->
          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters(["user"]),
    computedLines() {
      let total = 0;
      if (
        typeof this.manifestData != "undefined" &&
        this.manifestData.length > 0
      ) {
        return this.manifestData
          .map((item) => {
            const amount = parseFloat(item.Lines);
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  data: () => ({
    dataItem: {},
    loader: false,
    activeItem: {},
    Description: null,
    search: null,
    invoiceDialog: false,
    manifestData: [],
    docCreate: false,
    headers: [
      { text: "Customer", value: "ocrd.Name" },
      { text: "Phone No.", value: "ocrd.PhoneNumber" },
      { text: "Lines", value: "Lines" },
      //   { text: "Cost / Line", value: "LineCost" },
      { text: "Total", value: "DocTotal" },
      { text: "Action", value: "invoice" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    openInvoiceDialog(data) {
      this.activeItem = data;
      this.invoiceDialog = true;
    },
    createInvoice() {
      if (this.Description == null || this.Description == undefined) {
        this.$refs.snackbar.show("Please fill the description!", "red");
      } else {
        const self = this;
        let data = {
          container_id: self.activeItem.store_id,
          CardCode: self.activeItem.CardCode,
          Quantity: 1,
          Description: self.Description,
          LineTotal: self.activeItem.DocTotal,
          DocTotal: self.activeItem.DocTotal,
          user_id: self.dataItem.user_id,
          manifest_id: this.activeItem.id,
          DocDate: new Date().toISOString().substr(0, 10),
        };
        const url = "/manifest/invoice";
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              location.reload();
              self.loader = false;
            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/stores/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.dataItem = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });

      // fetch manifest
      this.$store
        .dispatch("get", `/manifest/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.manifestData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>